/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, { useContext, useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import useTypedSelector from "@Services/Hooks/UseTypedSelector";
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import { Button, Col, Form } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";

import { BHPCOURSE_INTERFACE, BHPCOURSE_QUIZ_ANSWERS_INTERFACE } from "@Services/Application/Interfaces/Users/User";

import { Row } from "react-bootstrap";
import { APPLICATION_ROUTER_INTERFACE } from "@DATA/Router/Interfaces/Router";
import { ApplicationRouterContext } from "@Contexts/Router";
import TimeLeftComponent from "./TimeLeft";
import QuizNextButtonComponent from "../QuizNextButton";
import SessionExtendComponent from "../SessionExtend";

type BhpQuizQuastionPageProps = { match?: any; location?: any; };

export const BhpQuizQuastionPageComponent: React.FC<BhpQuizQuastionPageProps> = ({
    match, location
}): JSX.Element | null => {

    const BHPCOURSE: BHPCOURSE_INTERFACE = location?.state?.bhpCourse;
    const ANSWERS_INPUT: BHPCOURSE_QUIZ_ANSWERS_INTERFACE[] = location?.state?.answers ?? [];
    const QUASTIONNO: number = location?.state?.quastionNo;
    const TERMINAL_NO : string = location?.state?.terminalNo;
    //var ENDTIME: Date = location?.state?.endTime;

    const[ENDTIME, setEndTime] = useState(location?.state?.endTime);

    const [ANSWERS, setAnswers] = useState(ANSWERS_INPUT);

    if (ENDTIME == undefined) {
        var endTime = new Date();
        endTime.setMinutes(endTime.getMinutes() + BHPCOURSE.Duration);
        setEndTime(endTime);
    }

    const DISPATCHER = useDispatch();

    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state): ReturnType<any> => state?.authentication
    )?.loggedUser || null;

    /** @const {object} INTERFACE_DATA - Application State Store Interface Data */
    const INTERFACE_DATA: ReturnType<any> = useTypedSelector(
        (state) => state.interface
    );

    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);
    const QUIZROUTE = ROUTER.AUTHENTICATED.SETTINGS.SETTINGS_MY_BHP_PAGE.QUIZ;

    const isChecked = (radioValue: string) => {
        let result = false;
        if (!!ANSWERS && !!ANSWERS[QUASTIONNO] && ANSWERS[QUASTIONNO].QuestionNo == BHPCOURSE.Questions[QUASTIONNO].QuestionNo) {
            ANSWERS[QUASTIONNO].Answers.forEach(element => {
                if (element.AnswerNo == radioValue) {
                    result = true;
                }
            });
        }
        return result;
    }

    const onAnswerChange = (event: any) => {
        let answer: BHPCOURSE_QUIZ_ANSWERS_INTERFACE =
        {
            QuestionNo: BHPCOURSE.Questions[QUASTIONNO].QuestionNo,
            Answers: []
        }
        answer.Answers.push({ AnswerNo: event.target.value });
        let newAnswers = JSON.parse(JSON.stringify(ANSWERS_INPUT));
        newAnswers[QUASTIONNO] = answer;
        setAnswers(newAnswers);
    }

    const getPictogram = (graphic:string):string => {
        try{
            return atob(graphic);
        }catch{
            return ''
        }
    }



    if (!LOGGED_USER || !LOGGED_USER?.userID) return null;

    return (
        <BlockContentContainerComponent cssClasses={"settings-page-user-data-component settings-page-view-component"}>

            <BlockContentHeaderComponent headerText={"Szkolenie BHP"} />

            <Col xs={12} className={"text-right"} >
                <TimeLeftComponent ENDTIME={ENDTIME} />
            </Col>

            {!!BHPCOURSE.Questions[QUASTIONNO] ?

                <Col xs={12} className={"user-profile-data user-information-data"}>
                    <SessionExtendComponent SESSIONMAXTIMESECONDS={BHPCOURSE.Duration * 60}/>
                    <Row className={"user-profile-data-content"}>

                        <Col xs={12} className={"user-information-section-component user-information-section user-document-data"} style={{ minHeight: "64vh" }}>
                            <Row className={"user-information-section-content"}>
                                <Col xs={12} className={"user-information-data user-important-information user-name"}>
                                    <span> Pytanie {QUASTIONNO + 1} z {BHPCOURSE.Questions.length}</span>
                                </Col>

                                <Col xs={12} className={"user-information-data"} style={{ marginTop: 40 }}>
                                    <span style={{fontSize:"1.2em"}}>{BHPCOURSE.Questions[QUASTIONNO].QuestionText}</span>
                                </Col>

                                <Col xs={12} className={"user-information-data"} style={{ marginTop: 40 }}>
                                    <img src={getPictogram(BHPCOURSE.Questions[QUASTIONNO].Graphics)}style={{ width: '100px', margin: '5px' }} />
                                </Col>

                                <Col xs={12} className={"user-information-data"} style={{ marginTop: 10, marginBottom: 40, fontSize:"1.2em" }}>
                                    <Col xs={12} onChange={onAnswerChange}>
                                        {BHPCOURSE.Questions[QUASTIONNO].Answers.map(answer => (
                                            <Form.Check style={{ marginTop: 10 }} >
                                                <Form.Check.Input
                                                    id={"radio" + answer.AnswerNo}
                                                    type="radio" value={answer.AnswerNo}
                                                    checked={isChecked(answer.AnswerNo)} 
                                                    onChange={onAnswerChange} />
                                                <Form.Check.Label htmlFor={"radio" + answer.AnswerNo}>{answer.AnswerText}</Form.Check.Label>
                                            </Form.Check>
                                        ))}
                                    </Col>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} style={{ marginTop: 30, textAlign: "center" }}>
                            {QUASTIONNO == 0 ?

                                <span></span>

                                :

                                <NavLink to={{ pathname: QUIZROUTE.QUIZQUASTION.URL, state: { bhpCourse: BHPCOURSE, quastionNo: QUASTIONNO - 1, answers: ANSWERS, endTime: ENDTIME, terminalNo: TERMINAL_NO } }} title={"Wstecz"}>
                                    <Button size={"sm"}>
                                        <span>{`Wstecz`}</span>
                                    </Button>
                                </NavLink>
                            }

                            {QUASTIONNO + 1 == BHPCOURSE.Questions.length ?

                                <QuizNextButtonComponent
                                    TO={{ pathname: QUIZROUTE.QUIZFINALIZATION.URL, state: { bhpCourse: BHPCOURSE, answers: ANSWERS, terminalNo: TERMINAL_NO } }}
                                    TITLE="Dalej"
                                    DISABLED={(ANSWERS[QUASTIONNO] === undefined)}
                                />

                                :
                                <QuizNextButtonComponent
                                    TO={{ pathname: QUIZROUTE.QUIZQUASTION.URL, state: { bhpCourse: BHPCOURSE, quastionNo: QUASTIONNO + 1, answers: ANSWERS, endTime: ENDTIME, terminalNo: TERMINAL_NO } }}
                                    TITLE="Dalej"
                                    DISABLED={(ANSWERS[QUASTIONNO] === undefined)}
                                />
                            }

                        </Col>

                    </Row>
                </Col >

                :

                <Col xs={12} className={"no-list-elements-message default-system-message"}>
                    <span>{`Brak informacji o pytaniu. Spróbuj ponownie później.`}</span>
                </Col>
            }

        </BlockContentContainerComponent >
    );

};


export default BhpQuizQuastionPageComponent;
